import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  margin-bottom: 10px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .div-data {
    display: flex;
    flex-direction: column;
    width: 90%;

    // border: 2px solid red;

    h2 {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .div-editar {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: var(--azul-razio);
    padding: 5px;
    height: 50px;
    // border: 2px solid var(--azul-razio);
  }

	// 479px
  @media (max-width: 29.9375rem) {
		 .div-data {
			h2 {
				font-size: 13px;
			}
		 }
	}
`;
